import React, {ReactElement, ReactNode} from 'react';
import {NxInputProps} from '..';
import InputMask from 'react-input-mask';
import NxInput from '../nxInput/NxInput';

export const MOBILE_NUMBER_MASK = '+63 999 999 9999'; // 9 means 0-9 number

export type NxPhoneInputProps = Omit<NxInputProps , 'type'> & {
  value?: string;
  mask?: string;
}

/**
 * InputMask passes down every prop except the following ones:
 * onChange, onPaste, onMouseDown, onFocus, onBlur, value, disabled, readOnly.
 */
const NxPhoneInput = (props: NxPhoneInputProps): ReactElement =>
  <InputMask {...props} mask={props.mask ?? MOBILE_NUMBER_MASK} maskChar={''}>
    {
      (inputProps: NxInputProps): ReactNode => <NxInput {...inputProps} type="tel" disabled={props.disabled} />
    }
  </InputMask>;

export default NxPhoneInput;
